module.exports = __webpack_public_path__ + "static/media/1017025.e7ef4e47.jpg";